import React from "react"
import { Icon, Container, Header } from "semantic-ui-react"

const style = {
  textAlign: "center",
  marginTop: "10px",
  marginBottom: "30px",
}

const IndexBanner = () => {
  return (
    <div style={style}>
      <Container text>
        <Header as="h2" icon style={{ fontFamily: "Saira", marginBottom: "0" }}>
          <Icon
            name="paper plane"
            color="teal"
            style={{ marginBottom: "15px" }}
          />
          Patrick & Yukiko
          <Header.Subheader style={{ marginTop: "10px" }}>
            After 5 years in{" "}
            <span role="img" aria-label="flag">
              🇯🇵
            </span>
            , we are leaving to{" "}
            <span role="img" aria-label="flag">
              🇬🇧
            </span>
            . Everything must go!
          </Header.Subheader>
        </Header>
      </Container>
    </div>
  )
}

export default IndexBanner
